import React from 'react';

interface ClientLastContactProps {
  days: number;
}

export default function ClientLastContact({ days }: ClientLastContactProps) {
  let label = '';
  let colorClass = 'text-slate-600 bg-slate-50 border-slate-200/60';
  let dotClass = 'bg-slate-400';

  if (days === 0) {
    label = 'Hoje';
    colorClass = 'text-emerald-700 bg-emerald-50/40 border-emerald-100/50';
    dotClass = 'bg-emerald-500';
  } else if (days === 1) {
    label = 'Ontem';
    colorClass = 'text-emerald-600 bg-emerald-50/20 border-emerald-100/30';
    dotClass = 'bg-emerald-400';
  } else if (days <= 5) {
    label = `há ${days} dias`;
    colorClass = 'text-slate-600 bg-slate-50 border-slate-200/60';
    dotClass = 'bg-slate-400';
  } else if (days <= 15) {
    label = `há ${days} dias`;
    colorClass = 'text-amber-700 bg-amber-50/40 border-amber-100/50';
    dotClass = 'bg-amber-500';
  } else {
    label = `há ${days} dias`;
    colorClass = 'text-rose-700 bg-rose-50/40 border-rose-100/50';
    dotClass = 'bg-rose-500 animate-pulse';
  }

  return (
    <div className={`inline-flex items-center gap-2 px-2.5 py-1.5 rounded-xl border text-xs font-bold ${colorClass}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dotClass}`} />
      <span className="flex items-center gap-1">
        {label}
      </span>
    </div>
  );
}
